import React from 'react'

import { PaymentTypes } from 'services/api/PaymentApi/types/common'

import { MODAL_ROUTE_PATH } from 'router/modalRoutes'

import Deposit from '../Deposit/Deposit'
import { PaymentModalWrapper } from '../PaymentModalWrapper/PaymentModalWrapper'
import { Withdrawal } from '../Withdrawal/Withdrawal'

const PaymentModal: React.FC<{ path: string }> = ({ path }) => {
  const paymentType = path === MODAL_ROUTE_PATH.DEPOSIT ? PaymentTypes.DEPOSIT : PaymentTypes.PAYOUT
  return (
    <PaymentModalWrapper path={path} paymentType={paymentType}>
      <>
        {paymentType === 'deposit' && <Deposit />}
        {paymentType === 'payout' && <Withdrawal />}
      </>
    </PaymentModalWrapper>
  )
}

export default PaymentModal
